export const CLOSE_IFRAME_SUCCESS = "CLOSE_IFRAME_SUCCESS"
export const CLOSE_IFRAME_FAILURE = "CLOSE_IFRAME_FAILURE"